import LoadingPanel from 'bz-core-controls/controls/layout/loading-panel';
import AuthStore from 'bz-stores/lib/auth-store';
import createReactClass from 'create-react-class';
import React from 'react';
import type { RouteComponentProps } from 'react-router-dom';
import { Link, withRouter } from 'react-router-dom';
import Api from 'tm3-core/api';

export interface IParams {
  code: string;
}

export interface IProps extends RouteComponentProps<IParams> {}

const VerifyEmail = createReactClass<IProps>({
  displayName: 'VerifyEmail',

  getInitialState() {
    const { code } = this.props.match.params;
    Api.get(`/api/user/verify/${code}`).then((x) => this.setState({ loading: false }));
    return { loading: true };
  },

  render() {
    return (
      <LoadingPanel loading={this.state.loading}>
        <div>
          <h2 className="p-t-35">Email Address Verified</h2>
          <p className="p-t-35">Thank you for verifying your email address.</p>
          <Link to="/login" className="text-info small pull-right">
            Take me to the login screen
          </Link>
        </div>
      </LoadingPanel>
    );
  }
});

export default withRouter(VerifyEmail);
